export default __webpack_public_path__ + "a06a9d31b1db69ef8dc91ad8a85ffe4a.png";